<template>
  <div @click.stop="clickTitle(datas)" :class="['fw','titleText']">{{datas.text}}</div>
  <slot></slot>
</template>
<script>
import { reactive, toRefs, computed } from 'vue'
export default {
  props: {
    datas: {
      type: Object,
      default: () => {}
    },
  },
  emits: ['click'],
  setup(props, { emit }) {
    let { datas } = toRefs(props)
    const state = reactive({
      datas
    })
    const clickTitle = v => {
      // console.log('clickTitle-->',v)
      emit('click', v)
    }
    return {
      ...toRefs(state),
      clickTitle
    }
  }
}
</script>
<style lang="scss" scoped>
.titleText{
  color: #333;
  font-size: 14px;
  line-height: 18px;
  vertical-align: middle;
}
.titleText::before {
  display: inline-block;
  width: 2px;
  height: 18px;
  margin: -1px 6px 0 0 ;
  content: '';
  background-color: #3088c5;
  vertical-align: middle;
}
</style>
